import {
  SLIP_DETAIL,
  SLIP_DETAIL_SUCCESS,
  SLIP_DETAIL_ERROR,
  SLIP_SELECT,
  SLIP_SELECT_SUCCESS,
  SLIP_SELECT_ERROR,
  SLIP_UPDATE,
  SLIP_UPDATE_SUCCESS,
  SLIP_UPDATE_ERROR,
  SLIP_QR_UPDATE,
  SLIP_QR_UPDATE_SUCCESS,
  SLIP_QR_UPDATE_ERROR,
} from "./actionTypes"

const initialState = {
  responseDetail: null,
  loadingDetail: false,
  errorDetail: "",
  responseSelect: null,
  loadingSelect: false,
  errorSelect: "",
  responseUpdate: null,
  loadingUpdate: false,
  errorUpdate: "",
  responseQRUpdate: null,
  loadingQRUpdate: false,
  errorQRUpdate: "",
}

const Slip = (state = initialState, action) => {
  switch (action.type) {
    case SLIP_DETAIL:
      state = {
        ...state,
        responseDetail: null,
        loadingDetail: true,
        errorDetail: "",
        responseSelect: null,
        responseUpdate: null,
        responseQRUpdate: null,
      }
      break
    case SLIP_DETAIL_SUCCESS:
      const data = {...action.payload.data}
      for (let i = 0; i < data.response.slipData.transactions.length; i++) {
        const vatRate = data.response.slipData.transactions[i].vatRate
        const account = data.response.slipData.transactions[i].account
        data.response.slipData.transactions[i].vatRate = {value: vatRate, label: vatRate + "%"}
        data.response.slipData.transactions[i].account = {value: account, label: account}
      }
      state = {
        ...state,
        responseDetail: data,
        loadingDetail: false,
      }
      break
    case SLIP_DETAIL_ERROR:
      state = {
        ...state,
        loadingDetail: false,
        errorDetail: action.payload,
      }
      break
    case SLIP_SELECT:
      state = {
        ...state,
        loadingSelect: true,
        errorSelect: "",
      }
      break
    case SLIP_SELECT_SUCCESS:
      const rd = state.responseDetail
      for (let i = 0; i < rd.response.slipData.transactions.length; i++) {
        action.payload.data.response.select.accounts.forEach((account) => {
          if (rd.response.slipData.transactions[i].account.value === account.value) {
            rd.response.slipData.transactions[i].account.label = account.label
          }
        })
      }
      state = {
        ...state,
        loadingSelect: false,
        responseSelect: action.payload.data,
        responseDetail: rd,
      }
      break
    case SLIP_SELECT_ERROR:
      state = {
        ...state,
        loadingSelect: false,
        errorSelect: action.payload
      }
      break
    case SLIP_UPDATE:
      state = {
        ...state,
        loadingUpdate: true,
        errorUpdate: "",
      }
      break
    case SLIP_UPDATE_SUCCESS:
      state = {
        ...state,
        responseUpdate: action.payload.data,
        loadingUpdate: false,
      }
      break
    case SLIP_UPDATE_ERROR:
      state = {
        ...state,
        loadingUpdate: false,
        errorUpdate: action.payload,
      }
      break
    case SLIP_QR_UPDATE:
      state = {
        ...state,
        loadingQRUpdate: true,
        errorQRUpdate: "",
      }
      break
    case SLIP_QR_UPDATE_SUCCESS:
      state = {
        ...state,
        responseQRUpdate: action.payload.data,
        loadingQRUpdate: false,
      }
      break
    case SLIP_QR_UPDATE_ERROR:
      state = {
        ...state,
        loadingQRUpdate: false,
        errorQRUpdate: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Slip
